/**
 * Created by jv on 15/05/2018.
 */
import Phaser from "phaser";
import config from "Sources/games/carrot-game/config/phaser";

// https://github.com/rblopes/phaser-3-snake-game
// https://photonstorm.github.io/phaser3-docs/list_namespace.html
// https://labs.phaser.io/
// http://localhost:9000/docs/boot_Config.js.html#line-104
// http://codetuto.com/2018/02/getting-started-phaser-3-es6-create-boomdots-game/
// https://github.com/CodeAndWeb/TexturePacker-Phaser3/blob/master/assets/cityscene.json
// https://developer.amazon.com/post/Tx3AT4I2ENBOI6R/Intro-to-Phaser-Part-3-Obstacles-Collision-Score-Sound-and-Publishing
// http://codetuto.com/2018/03/getting-started-phaser-3-es6-create-boomdots-game-part-2/
// http://www.html5gamedevs.com/topic/36930-seperating-update-loop-of-game-from-update-loop-of-rendering/
// https://hacks.mozilla.org/2016/06/webfont-preloading-for-html5-games/
// http://www.html5gamedevs.com/topic/21724-spawning-enemies-at-random-period/

export default function init(parent)
{
  config.parent = parent;

  return new Phaser.Game(config);
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/index.js